// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import positionPaperResponseEntity from './entities/position-paper-response.json';
import positionPaperResponseMenu from '../pages/position-paper-response/menu.json';
import positionPaperResponseFullForm from '../pages/position-paper-response/forms/full.json';
import positionPaperResponseContextForm from '../pages/position-paper-response/forms/context.json';
import positionPaperResponseMiniForm from '../pages/position-paper-response/forms/mini.json';
import positionPaperResponseLookupForm from '../pages/position-paper-response/forms/lookup.json';
import positionPaperResponseTableView from '../pages/position-paper-response/views/table.json';
import positionPaperResponseCardsView from '../pages/position-paper-response/views/cards.json';
import positionPaperResponseDashboardView from '../pages/position-paper-response/views/dashboard.json';

/** Тип запису «Відповідь комітету» зі сторінками пакета: меню, форми та подання з pages/position-paper-response/. */
export const positionPaperResponseDefinition: IRecordTypeDefinition = {
  ...positionPaperResponseEntity,
  views: assembleViewSet({
      table: positionPaperResponseTableView,
      cards: positionPaperResponseCardsView,
      dashboard: positionPaperResponseDashboardView,
  }),
  form: positionPaperResponseFullForm,
  forms: { full: positionPaperResponseFullForm, context: positionPaperResponseContextForm, mini: positionPaperResponseMiniForm, lookup: positionPaperResponseLookupForm },
  menu: positionPaperResponseMenu,
} as IRecordTypeDefinition;
